<div [class]="kebabCaseTemplateType(block.data.templateType)">
  <div class="hero-container" [class.sidebar]="block.data.hasSidebar">
    @if (block.data.templateType === 'Article') {
      <div class="hero-color">
        <h1>{{ currentPageName }}</h1>
      </div>
    } @else if (block.data.templateType === 'Interior') {
      <div class="hero-color"></div>
      <img [src]="theIcon" alt="" />
    } @else if (block.data.templateType === 'Category Landing') {
      <div class="cat-hero-wrapper">
        <div class="cat-hero-wrapper-inner wrapper-inner d-flex align-items-center">
          <div class="cat-hero-info">
            <h1 [innerText]="currentPage.name | translate"></h1>
            @if (currentPage.description !== '') {
              <p [innerText]="currentPage.description | translate"></p>
            }
          </div>
          <img class="cat-hero-img" [src]="theIcon" alt="" />
        </div>
      </div>
    }
  </div>

  <div class="breadcrumb-container" [class.sidebar]="block.data.hasSidebar" coreLinkClass>
    <ul class="breadcrumbs">
      <li><a routerLink="/" [innerText]="'Home' | translate"></a></li>
      @if (breadcrumbs$ | async; as breadcrumbs) {
        @for (breadcrumb of breadcrumbs.parents; track breadcrumb) {
          <li>
            <a
              [routerLink]="getLink(breadcrumb)"
              [core-analytics]="{ action: breadcrumb.name, block }"
              [innerText]="breadcrumb.name | translate"></a>
          </li>
        }
        <li [innerText]="breadcrumbs.name | translate"></li>
      }
    </ul>
  </div>

  <div class="page-template-grid" [class.sidebar]="block.data.hasSidebar">
    <div class="page-template-content-container">
      <!--Display children of current page in tiles-->
      @if (block.data.templateType === 'Category Landing') {
        @if (theChildren) {
          <div class="cat-children-container">
            @for (child of theChildren; track child.id) {
              <a href="{{ child.url }}" class="cat-child" coreLinkClass>
                <h4>{{ child.name | translate }}</h4>
                @if (child.meta.description !== undefined) {
                  <p>{{ child.meta.description | translate }}</p>
                }
                <p class="cat-child-readmore">
                  {{ 'Learn More' | translate }}
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4 11.5306C4 10.9896 4.43858 10.551 4.97959 10.551L16.4565 10.551L12.1631 6.70963C11.76 6.34889 11.7256 5.7296 12.0863 5.32641C12.447 4.92323 13.0663 4.88882 13.4695 5.24957L19.6736 10.8006C19.8813 10.9864 20 11.2519 20 11.5306C20 11.8093 19.8813 12.0748 19.6736 12.2607L13.4695 17.8117C13.0663 18.1724 12.447 18.138 12.0863 17.7348C11.7256 17.3316 11.76 16.7124 12.1631 16.3516L16.4565 12.5102L4.97959 12.5102C4.43858 12.5102 4 12.0716 4 11.5306Z" />
                  </svg>
                </p>
              </a>
            }
          </div>
        }
      }

      @for (subBlock of block.content; track subBlock) {
        <core-block [block]="subBlock" class="subWidget {{ subBlock.data.class }}"></core-block>
      }
    </div>
    @if (block.data.hasSidebar) {
      <div class="page-template-sidebar-container">
        @if (block.data.CTAContent !== '') {
          <div class="sidebar-CTA-container">
            <div class="sidebar-CTA-image">
              @if (block.data.image) {
                <img [src]="frontend + block.data.image" alt="" />
              }
            </div>
            <div class="sidebar-CTA-content" [innerHTML]="block.data.CTAContent"></div>
            <core-coro-button [button]="block.data.CTAbutton"></core-coro-button>
          </div>
        }
        @if (block.data.contacts !== '') {
          <div class="sidebar-contacts-container">
            <h3>{{ 'Contacts' | translate }}</h3>
            <div class="sidebar-contacts-wrapper" [innerHTML]="block.data.contacts"></div>
            <a class="internal" href="/contacts">{{ 'View all' | translate }}</a>
          </div>
        }
        @if (block.data.resources !== '') {
          <div class="sidebar-resources-container">
            <h3>{{ 'Related Resources' | translate }}</h3>
            <div class="sidebar-resources-wrapper" [innerHTML]="block.data.resources"></div>
          </div>
        }
      </div>
    }
  </div>
</div>
